import React from 'react';

interface IconProps extends React.SVGProps<SVGSVGElement> {
  fillColor?: string; // Accepts color values or 'currentColor'
}

const GeneratingIcon: React.FC<IconProps> = ({ fillColor, ...props }) => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <circle cx="6" cy="6" r="1" fill={fillColor || 'white'} fillOpacity="0.35" />
      <circle cx="9" cy="6" r="1" fill={fillColor || 'white'} fillOpacity="0.35" />
      <circle cx="12" cy="6" r="1" fill={fillColor || 'white'} fillOpacity="0.35" />
      <circle cx="15" cy="6" r="1" fill={fillColor || 'white'} fillOpacity="0.35" />
      <circle cx="18" cy="6" r="1" fill={fillColor || 'white'} fillOpacity="0.35" />
      <circle cx="6" cy="9" r="1" fill={fillColor || 'white'} fillOpacity="0.35" />
      <circle cx="9" cy="9" r="1" fill={fillColor || 'white'} fillOpacity="0.35" />
      <circle cx="12" cy="9" r="1" fill={fillColor || 'white'} fillOpacity="0.35" />
      <circle cx="15" cy="9" r="1" fill={fillColor || 'white'} fillOpacity="0.35" />
      <circle cx="18" cy="9" r="1" fill={fillColor || 'white'} fillOpacity="0.35" />
      <circle cx="6" cy="12" r="1" fill={fillColor || 'white'} />
      <circle cx="9" cy="12" r="1" fill={fillColor || 'white'} />
      <circle cx="12" cy="12" r="1" fill={fillColor || 'white'} />
      <circle cx="15" cy="12" r="1" fill={fillColor || 'white'} fillOpacity="0.35" />
      <circle cx="18" cy="12" r="1" fill={fillColor || 'white'} />
      <circle cx="6" cy="15" r="1" fill={fillColor || 'white'} fillOpacity="0.35" />
      <circle cx="9" cy="15" r="1" fill={fillColor || 'white'} fillOpacity="0.35" />
      <circle cx="12" cy="15" r="1" fill={fillColor || 'white'} fillOpacity="0.35" />
      <circle cx="15" cy="15" r="1" fill={fillColor || 'white'} fillOpacity="0.35" />
      <circle cx="18" cy="15" r="1" fill={fillColor || 'white'} fillOpacity="0.35" />
      <circle cx="6" cy="18" r="1" fill={fillColor || 'white'} fillOpacity="0.35" />
      <circle cx="9" cy="18" r="1" fill={fillColor || 'white'} fillOpacity="0.35" />
      <circle cx="12" cy="18" r="1" fill={fillColor || 'white'} fillOpacity="0.35" />
      <circle cx="15" cy="18" r="1" fill={fillColor || 'white'} fillOpacity="0.35" />
      <circle cx="18" cy="18" r="1" fill={fillColor || 'white'} fillOpacity="0.35" />
    </svg>
  );
};

export { GeneratingIcon };
